module.exports = __webpack_public_path__ + "img/chart-walking-phase-average-degraded.2a417c49.png";